module.exports = __webpack_public_path__ + "static/media/icomoon.58544888.eot";